import React from 'react';
import {hashHistory, Link} from 'react-router';
import {Paper, CircularProgress} from 'material-ui';
// import RainfallWatch from '../Watch/RainfallWatch'
import {inject, observer} from 'mobx-react';

@inject('markerStore')
@observer
export default class MiniRiverWatch extends React.Component {

  getSortedArray = (items) => {
    let sortedArray = [];
    let dangerItems = items.filter(item => item.status === 'DANGER').sort((a, b) => +a.stationIndex < +b.stationIndex ? -1 : 1);
    let warningItems = items.filter(item => item.status === 'WARNING').sort((a, b) => +a.stationIndex < +b.stationIndex ? -1 : 1);
    let bwlItems = items.filter(item => item.status === 'BELOW WARNING LEVEL').sort((a, b) => +a.stationIndex < +b.stationIndex ? -1 : 1);
    // let ndItems = items.filter(item => item.status === null);

    if (dangerItems.length) sortedArray = [...sortedArray, ...dangerItems.filter(b => !!b.stationIndex), ...dangerItems.filter(b => (!b.stationIndex || b.stationIndex === null || b.stationIndex === ''))];
    if (warningItems.length) sortedArray = [...sortedArray, ...warningItems.filter(b => !!b.stationIndex), ...warningItems.filter(b => (!b.stationIndex || b.stationIndex === null || b.stationIndex === ''))];
    if (bwlItems.length) sortedArray = [...sortedArray, ...bwlItems.filter(b => b.stationIndex), ...bwlItems.filter(b => (b.stationIndex === null || b.stationIndex === ''))];
    // if(ndItems.length) sortedArray = [ ...sortedArray, ...ndItems.sort((a,b) => a.stationIndex && a.name < b.name ?-1:1)];

    return sortedArray;
  };

  onClickHeader = () => hashHistory.push('/river_watch');

  render() {
    let {markerStore} = this.props;
    let getColor = status => {
      switch (status) {
        case 'BELOW WARNING LEVEL':
          return 'green';
        // case 'WARNING':
        //   return 'coral';
        // case 'DANGER':
        //   return 'red';
        default:
          return '';
      }
    };
    let riverWatchData = markerStore.river_raw ? this.getSortedArray(markerStore.river_raw.filter(item => item.waterLevel && item.waterLevel !== 'N/A' && !!item.waterLevel.value)) : [];
    return (
      <Paper zDepth={1} style={{width: this.props.mobView?'49%':'100%', height: '280px'}}>
        <h5 className="myTableHead">
          River Watch
          <span className="pull-right" style={{fontWeight: '100', fontSize: 'small'}} onClick={this.onClickHeader}>see all</span>
        </h5>
        <ul style={{maxHeight: '242px', overflowY: 'scroll', margin: '0px'}}>{
          riverWatchData ? riverWatchData.map((item, index) => (
            <li style={{marginLeft: 0}}>
              <Link to={`/basin/${item.id}`}  className={item.status ? `${item.status.split(' ')[0]}_RIVER mini-watch-item` : 'mini-watch-item'}>
                <div>{item.name}</div>
                <div className="inline-it">
                  <div style={{color: getColor(item.status)}}>{item.waterLevel && item.waterLevel.value>0 ? Math.round(item.waterLevel.value*1000)/1000 + ' m' : 'N/A'}</div>{' '}
                  {/*<div>{item.waterLevel && item.waterLevel.value>0 ? Math.round(item.waterLevel.value*1000)/1000 + ' m' : 'N/A'}</div>{' '}*/}
                  {item.waterLevel && item.waterLevel.value>0 && <span className={item.steady === 'RISING' ? 'glyphicon glyphicon-arrow-up' : item.steady === 'FALLING' ? 'glyphicon glyphicon-arrow-down' : ''}/>}
                </div>
              </Link>
            </li>
          )) :
            <div className="spinner"><CircularProgress/></div>
        }</ul>
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home/MiniRiverWatch.js